import styled from "styled-components"

const ExpandedTableCell = styled.td`
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
`

export default ExpandedTableCell